import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartButton from '../../../components/CartButton';
import { useWishlist } from '../../../context/WishlistContext';

export default function WishlistNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const { totalItems } = useWishlist();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-stone-950/95 backdrop-blur-xl shadow-2xl shadow-black/20 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 cursor-pointer group">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
                alt="House of FMR"
                className="h-14 w-14 object-contain transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-amber-400/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <div className="hidden sm:block">
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300 font-display text-xl tracking-wide">House of FMR</p>
              <p className="text-amber-400/80 text-[10px] tracking-[0.25em] uppercase font-medium">Events & Styling</p>
            </div>
          </Link>

          {/* Actions */}
          <div className="flex items-center gap-4">
            <Link
              to="/wishlist"
              className="relative w-11 h-11 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-heart-3-fill text-xl text-rose-400"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-rose-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {totalItems}
                </span>
              )}
            </Link>
            <CartButton />
            <Link
              to="/"
              className="hidden md:flex px-6 py-2.5 bg-gradient-to-r from-amber-400 to-yellow-300 text-stone-900 text-sm font-semibold rounded-full hover:from-amber-300 hover:to-yellow-200 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/20"
            >
              Back to Shop
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
